import { render } from "./AuMarkdownView.vue?vue&type=template&id=3bc0e63d&scoped=true"
import script from "./AuMarkdownView.vue?vue&type=script&lang=js"
export * from "./AuMarkdownView.vue?vue&type=script&lang=js"

import "./AuMarkdownView.vue?vue&type=style&index=0&id=3bc0e63d&scoped=true&lang=scss"
import "./AuMarkdownView.vue?vue&type=style&index=1&id=3bc0e63d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc0e63d"]])

export default __exports__